import apiClient from './api';

// Community Service
export const communityService = {
  // Lấy danh sách posts
  getPosts: async (page = 1, limit = 10, category = null) => {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString()
      });
      if (category) params.append('category', category);
      
      const response = await apiClient.get(`/community/posts?${params}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Tạo post mới
  createPost: async (postData) => {
    try {
      const response = await apiClient.post('/community/posts', postData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Cập nhật post
  updatePost: async (postId, postData) => {
    try {
      const response = await apiClient.put(`/community/posts/${postId}`, postData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Xóa post
  deletePost: async (postId) => {
    try {
      const response = await apiClient.delete(`/community/posts/${postId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Like/Unlike post
  toggleLike: async (postId) => {
    try {
      const response = await apiClient.post(`/community/posts/${postId}/like`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Thêm comment
  addComment: async (postId, comment) => {
    try {
      const response = await apiClient.post(`/community/posts/${postId}/comments`, {
        content: comment
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Lấy comments của post
  getComments: async (postId, page = 1, limit = 20) => {
    try {
      const response = await apiClient.get(`/community/posts/${postId}/comments?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};
